import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Label from '../texts/label'
import SmallText from '../texts/small-text'
import CaptionText from '../texts/caption-text'

const FieldBlock = props => (
  <div
    className={classNames({
      'field-block': true,
      [props.className]: props.className
    })}
  >
    {props.hasHeader ? (
      <div
        className={classNames({
          'field-header': true,
          'has-note': props.hasNote
        })}
      >
        <Label shyLabel={props.shyLabel}>{props.titleLabel}</Label>
        {props.note ? <p className='note'>{props.note}</p> : null}
        {props.smallText ? <SmallText>{props.smallText}</SmallText> : null}
        {props.captionText ? (
          <CaptionText>{props.captionText}</CaptionText>
        ) : null}
      </div>
    ) : null}
    {props.children}
  </div>
)

FieldBlock.propTypes = {
  titleLabel: PropTypes.string,
  hasHeader: PropTypes.bool,
  shyLabel: PropTypes.bool,
  note: PropTypes.string,
  smallText: PropTypes.string,
  hasNote: PropTypes.bool
}

FieldBlock.defaultProps = {
  hasHeader: true
}

export default FieldBlock



// WEBPACK FOOTER //
// ./src/ui/forms/field-block.js